import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Actions_Wind from "~/Actions_Wind";
import Actions_Wind_V2 from "~/Actions_Wind_V2";
import permission from "~/skills/permission";
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TablePagination, Link, Grid, makeStyles } from "@material-ui/core";
import ProgressTrackingViewDialogForManager from "./dialogs/ProgressTrackingViewDialogForManager";

const useStyles = makeStyles((theme) => ({
    searchButton: {
        backgroundColor: "#5597b4",
        color: "#fff",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#3E8CCB",
        },
    },
    addButton: {
        backgroundColor: "#fff",
        color: "#5597b4",
        border: "1px solid #5597b4",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#E6F2FB",
        },
    },
    editButton: {
        backgroundColor: "#fff",
        color: "#5597b4",
        border: "1px solid #5597b4",
        borderRadius: "6px",
        "&:hover": {
            backgroundColor: "#E6F2FB",
        },
    },
    viewButton: {
        backgroundColor: "#5597b4",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#3E8CCB",
        },
    },
    deleteButton: {
        backgroundColor: "#999",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#777",
        },
    },
    downloadButton: {
        backgroundColor: "#74d6d4",
        color: "#fff",
        borderRadius: "4px",
        "&:hover": {
            backgroundColor: "#0ABAB5",
        },
    },
    headerRow: {
        backgroundColor: "#f7f7f7",
    },
    oddRow: {
        backgroundColor: "#E6F7FB",
    },
}));

function Page_PPTrackManagement(props) {
    const { getManagerProgressTrackingSheetDocuments } = props;
    const classes = useStyles();
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const addBtnRef = useRef(null);

    const handleSearch = async () => {
        try {
            const body = {
                keyword: search,
                page_index: page + 1,
                page_size: rowsPerPage,
                windcontract_id: Actions_Wind.wind_id(),
            };

            const result = await getManagerProgressTrackingSheetDocuments(body);

            if (result?.data?.data) {
                const docs = result.data.data.map((item, idx) => ({
                    id: item.id,
                    serial: page * rowsPerPage + idx + 1,
                    report_date: item.report_date || "-",
                    last_updated_date: item.last_updated_date || "-",
                    submitted_date: item.submitted_date || "-",
                    user_name: item.user_name || "-",
                    status: item.status?.description || "-",
                    status_code: item.status?.code || 0,
                }));
                setRows(docs);
                setTotalCount(result.data.pagination_info.total || 0);
            }
        } catch (error) {
            console.error("Error fetching documents:", error);
        }
    };
    
    useEffect(() => {
        handleSearch();
    }, [page, rowsPerPage]);

    const handleView = (id) => {
        setSelectedId(id);
        setViewDialogOpen(true);
    };

    // 分頁控制
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Box
            p={3}
            display="flex"
            flexDirection="column"
            style={{
                overflowY: "auto",
            }}
        >
            <Typography
                variant="h6"
                gutterBottom
                style={{ fontWeight: "bold", textAlign: "left", marginRight: "auto" }}
            >
                各工程進度
            </Typography>

            {/* 搜尋 */}
            <Grid container spacing={2} alignItems="center" style={{ marginBottom: 16 }}>
                <Grid item>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="請輸入關鍵字"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        className={classes.searchButton}
                        onClick={() => {
                            setPage(0); // 搜尋時重設 page
                            handleSearch();
                        }}
                    >
                        查詢
                    </Button>
                </Grid>
            </Grid>

            {/* 表格 */}
            <TableContainer component={Paper} style={{ maxHeight: "60vh", overflowY: "auto" }}>
                <Table>
                    <TableHead>
                        <TableRow className={classes.headerRow}>
                            <TableCell>序號</TableCell>
                            <TableCell>報表日期</TableCell>
                            <TableCell>填報者</TableCell>
                            <TableCell>送件時間</TableCell>
                            <TableCell>狀態</TableCell>
                            <TableCell style={{ textAlign: "center" }}>功能</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, idx) => (
                            <TableRow
                                key={row.id}
                                className={idx % 2 === 0 ? classes.oddRow : ""}
                            >
                                <TableCell>{row.serial}</TableCell>
                                <TableCell>{row.report_date}</TableCell>
                                <TableCell>{row?.user_name || "-"}</TableCell>
                                <TableCell>{row?.submitted_date || "-"}</TableCell>
                                <TableCell>{row?.status || "-"}</TableCell>
                                <TableCell>
                                    <Box display="flex" gridGap={8}>
                                        <Button size="small" className={classes.viewButton} onClick={() => handleView(row.id)}>
                                            檢視
                                        </Button>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                {/* 分頁 */}
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onChangePage={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    labelRowsPerPage="每頁筆數"
                    labelDisplayedRows={({ from, to, count }) =>
                        `第 ${from}-${to} 筆，共 ${count} 筆`
                    }
                />
            </TableContainer>

            {/* 檢視 Dialog */}
            {
                viewDialogOpen && (
                    <ProgressTrackingViewDialogForManager
                        open={viewDialogOpen}
                        onClose={() => setViewDialogOpen(false)}
                        sheetId={selectedId}
                        getDocument={Actions_Wind_V2.getAProgressTrackingSheetDocument}
                    />
                )
            }
        </Box>
    );
}

const mapStateToProps = (state) => ({
    sign: state.data?.AtyFunction,
    ProjectProgressList: state.data?.ProjectProgressList || {},
    ...permission.returnPermission(state),
});

const mapDispatchToProps = (dispatch) => ({
    getProjectProgressList: (body) => Actions_Wind.getProjectProgressList(dispatch, body),
    getManagerProgressTrackingSheetDocuments: (body) => Actions_Wind_V2.getManagerProgressTrackingSheetDocuments(body),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_PPTrackManagement);
